"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toast = exports.ToastType = void 0;
var localization_1 = require("./localization");
var ToastType;
(function (ToastType) {
    ToastType["Saved"] = "saved";
    ToastType["Success"] = "success";
    ToastType["Error"] = "error";
})(ToastType || (exports.ToastType = ToastType = {}));
var Toast = /** @class */ (function () {
    function Toast() {
    }
    Toast.prototype.showToast = function (type, message) {
        if (window.eventBus) {
            window.eventBus.$emit('toast:show', { type: type, message: message });
        }
        else {
            console.info("Toast: ".concat(type, " - ").concat(message));
        }
    };
    Toast.prototype.saved = function () {
        this.showToast(ToastType.Success, (0, localization_1.localize)('allChangesAreSaved'));
    };
    Toast.prototype.success = function (message) {
        this.showToast(ToastType.Success, message);
    };
    Toast.prototype.error = function (message) {
        if (message === void 0) { message = (0, localization_1.localize)('anErrorOccurred'); }
        this.showToast(ToastType.Error, message);
    };
    return Toast;
}());
exports.toast = new Toast();
